import AddIcon from '@mui/icons-material/Add';
import { useConfirm } from "material-ui-confirm";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ActionButtons } from "../../../constants/actionButtons";
import { AppRoutes } from "../../../constants/appRoutes";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import { TableActionColumn } from "../../../shared/components/common/tableActionColumn";
import ButtonWrapper from "../../../shared/formUtilities/useButton";
import DataTableGrid from "../../../shared/formUtilities/useTable";
import { SMSNotificationService } from "../smsNotificationService";
import { initializeColumnsSMSNotications } from "./smsNotificationColumns";
import { SMSSendDialog } from './smsSendDialog';

export const SMSNotificationList = () => {
  const smsNotificationService = new SMSNotificationService();
  const [smsNotifications, setSmsNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [detail, setDetail] = useState({});
  const navigate = useNavigate();
  const confirm = useConfirm();

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAll = () => {
    setLoading(true);
    smsNotificationService
      .getSMSNotification()
      .then((resp) => {
        setSmsNotifications(resp.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const columns = [
    ...initializeColumnsSMSNotications(),
    TableActionColumn({
      visibleActionsList: [
        ActionButtons.Send,
        ActionButtons.Edit,
        ActionButtons.Delete,
      ],
      onEdit: (e, row) => {
        onEdit(e, row);
      },
      onDelete: (e, row) => {
        onDelete(row);
      },
      onSend: (e, row) => {
        onSend(row);
      },
      width: 200,
    }),
  ];

  const onSend = (row) => {
    setDetail(row);
    setIsSend(true);
  };

  const onEdit = (e, row) => {
    e.stopPropagation();
    navigate(buildRegionizeRoute(`${AppRoutes.SMSNotification}/edit/${row?.id}`));
  };

  const onDelete = (row) => {
    confirm({
      description: `Are you sure you want to delete this sms notification?`,
      title: 'Confirm!',
      confirmationButtonProps: {
        className: '!bg-red-500 !text-white !capitalize',
      },
      confirmationText: 'Delete',
      cancellationButtonProps: { className: '!capitalize' },
    })
      .then(() => {
        setLoading(true);
        smsNotificationService
          .deleteSMSNotifications(row?.id)
          .then((resp) => {
            getAll();
          })
          .catch((err) => {
            setLoading(false);
          });
      })
      .catch(() => console.log('cancelled.'));
  };

  const onAdd = () => {
    navigate(buildRegionizeRoute(`${AppRoutes.SMSNotification}/create/`));
  };

  return (
    <>
      <DataTableGrid
        columnPinning={['action']}
        actionButtons={
          <ButtonWrapper
            disabled={loading}
            onClick={() => {
              onAdd();
            }}
            icon={<AddIcon />}
            label="Create"></ButtonWrapper>
        }
        name={'smsNotificationTbl'}
        columns={columns}
        records={smsNotifications}
        showEditColumnsButton={true}
        isPagination={false}
        loading={loading}
        heading={'SMS Notifications'}></DataTableGrid>
      {isSend ? (
        <>
          <SMSSendDialog
            state={isSend}
            notificationDetail={detail}
            onClose={() => {
              setIsSend(false);
            }}></SMSSendDialog>
        </>
      ) : null}
    </>
  );
};